import React from 'react';
import { IIconProps } from '../interfaces';

const AleaRefreshIcon: React.FC<IIconProps> = ({
  color = 'white',
  size = '18',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size === '18' ? '21' : size}
    viewBox="0 0 18 21"
    fill="none"
  >
    <path
      d="M8.40961 18.4838C4.06812 18.4838 0.547852 15.0128 0.547852 10.7288C0.547852 8.70315 1.21304 6.86089 2.48865 5.47852"
      stroke={color}
      strokeWidth="1.09495"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M7.95648 20.8226C7.69489 20.9935 7.34961 20.8226 7.34961 20.4809V16.027C7.34961 15.6852 7.69838 15.5143 7.95648 15.6852L9.95495 16.7978L11.9534 17.9104C12.215 18.0813 12.215 18.5103 11.9534 18.6812L9.95495 19.7938L7.95648 20.8226Z"
      fill={color}
    />
    <path
      d="M9.48535 2.55273C13.8268 2.55273 17.3471 6.02921 17.3471 10.3159C17.3471 12.4183 16.5013 14.3235 15.1271 15.7195"
      stroke={color}
      strokeWidth="1.09495"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9.93825 0.0670446C10.1998 -0.103855 10.5451 0.0670444 10.5451 0.408843V4.86966C10.5451 5.21146 10.1963 5.38584 9.93825 5.21146L7.93978 4.09538L5.9413 2.97931C5.67972 2.80841 5.67972 2.37941 5.9413 2.20852L7.93978 1.09244L9.93825 0.0635574V0.0670446Z"
      fill={color}
    />
  </svg>
);

export default AleaRefreshIcon;

